import { Paper, Table, Text } from '@mantine/core';
import type { ComponentPropsWithoutRef } from 'react';
import { UnifyTable, type UnifyTableColumn, type UnifyTableProps } from '@/components/UnifyTable';
import { CARD_TABLE_PAPER_PROPS, CARD_TABLE_STYLES } from '@/components/unifyTableVariants';

export function cardTableColumns<T>(columns: UnifyTableColumn<T>[]): UnifyTableColumn<T>[] {
  return columns.map((col) => ({
    ...col,
    renderHeader:
      col.renderHeader ??
      (() => (
        <Text size="xs" fw={500} c="gray.6">
          {col.label}
        </Text>
      )),
  }));
}

export type UnifyCardTableProps<T> = Omit<UnifyTableProps<T>, 'withPaper' | 'scrollMinWidth'> & {
  tableProps?: ComponentPropsWithoutRef<typeof Table>;
};

export function UnifyCardTable<T>({
  columns,
  tableProps,
  ...rest
}: UnifyCardTableProps<T>): JSX.Element {
  return (
    <Paper {...CARD_TABLE_PAPER_PROPS}>
      <UnifyTable
        {...rest}
        columns={cardTableColumns(columns)}
        withPaper={false}
        scrollMinWidth={0}
        tableProps={{
          w: '100%',
          highlightOnHover: false,
          withRowBorders: false,
          styles: CARD_TABLE_STYLES,
          ...tableProps,
        }}
      />
    </Paper>
  );
}
